export const dynamicGrid = (items, numColumns) => {
  const totalItems = items.length;

  const baseItemsPerCol = Math.floor(totalItems / numColumns);
  const remainder = totalItems % numColumns;

  let currentItemIndex = 0;

  for (let col = 1; col <= numColumns; col++) {
    const itemsInThisCol = baseItemsPerCol + (col <= remainder ? 1 : 0);

    for (let row = 1; row <= itemsInThisCol; row++) {
      if (currentItemIndex >= totalItems) break;

      const item = items[currentItemIndex];

      item.style.gridColumn = col.toString();
      item.style.gridRow = row.toString();

      currentItemIndex++;
    }
  }
};
